import { useTranslation } from 'react-i18next';
import { Link as LinkIcon } from 'lucide-react';

export function InvalidLinkPage() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-full p-4">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 rounded-2xl bg-muted/60 flex items-center justify-center mx-auto mb-4">
          <LinkIcon className="h-7 w-7 text-muted-foreground/40" />
        </div>
        <h1 className="text-xl font-bold mb-2">{t('portal.invalidLink')}</h1>
        <p className="text-sm text-muted-foreground">{t('portal.linkExpired')}</p>
      </div>
    </div>
  );
}
